const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

/** ContentPage opens resources through its existing query parameter. */
export function contentHref(id: string, seconds: number | null = null): string {
  const params = new URLSearchParams({ open: id });
  if (seconds !== null) params.set('t', String(seconds));
  return `/content?${params}`;
}

/** Parses an internal content href like /content/{uuid}?t=364 */
export function parseContentHref(href: string): { id: string; seconds: number | null } | null {
  const canonical = href.match(new RegExp(`^(?:https?://[^/]+)?/content\\?(.+)$`, 'i'));
  if (canonical) {
    const params = new URLSearchParams(canonical[1]);
    const id = params.get('open');
    if (!id || !new RegExp(`^${UUID}$`, 'i').test(id)) return null;
    const seconds = params.get('t');
    return { id: id.toLowerCase(), seconds: seconds && /^\d+$/.test(seconds) ? Number(seconds) : null };
  }
  const m = href.match(new RegExp(`^(?:https?://[^/]+)?/content/(${UUID})(?:\\?t=(\\d+))?`, 'i'));
  if (!m) return null;
  return { id: m[1].toLowerCase(), seconds: m[2] ? Number(m[2]) : null };
}

/**
 * Turns bare "/content/{uuid}" references (often written like "*Título*(/content/uuid)")
 * into markdown links so they render as cards. Existing markdown links are kept.
 */
export function linkifyContentRefs(text: string): string {
  // "*Title*(/content/id)" or "Title (/content/id)" without brackets → [Title](/content/id)
  const re = new RegExp(`(\\*{1,2})?([^\\[\\]\\n*(]{2,120}?)\\1\\s*\\((/content/${UUID}(?:\\?t=\\d+)?)\\)`, 'gi');
  let out = text.replace(re, (full, _s, title, path, offset: number, src: string) => {
    if (src[offset - 1] === ']' || src[offset - 1] === '[') return full;
    const lead = title.match(/^\s*/)?.[0] ?? '';
    return `${lead}[${title.trim()}](${path})`;
  });
  // Any remaining bare path not inside parentheses of a link
  out = out.replace(new RegExp(`(^|[\\s:])(/content/${UUID}(?:\\?t=\\d+)?)`, 'gi'), (_f, pre, path) => `${pre}[Ver video](${path})`);
  return out;
}

export function formatSeconds(s: number): string {
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}
